'use strict'

moment = require 'moment'
DATE_FORMAT = 'YYYY-MM-DD'

ID_NEXT_WEEK = "nextWeek"
FRIENDLY_NEXT_WEEK = "Next Week"

ID_THIS_WEEKEND = "thisWeekend"
FRIENDLY_THIS_WEEKEND = "This Weekend"

ID_NEXT_WEEKEND = "nextWeekend"
FRIENDLY_NEXT_WEEKEND = "Next Weekend"

module.exports =
  getFormattedAvailability: (dates) ->
    return null unless dates

    formattedChildren = []

    thisWeekendCount = 0
    nextWeekCount = 0
    nextWeekendCount = 0
    nextFriday = null

    for date in dates
      switch
        when date.id is 'anyday' then break
        when date.id is 'weekend' then break
        when date.id is 'friday'
          thisWeekendCount += date.count
        when date.id is 'sunday'
          thisWeekendCount += date.count
        when date.id is 'saturday'
          thisWeekendCount += date.count
        when date.id is 'today'
          formattedChild = _createNewFacet(date.id, date.friendlyName, date.id, date.count)
          formattedChildren.push(formattedChild)
        when date.id is 'tomorrow'
          formattedChild = _createNewFacet(date.id, date.friendlyName, date.id, date.count)
          formattedChildren.push(formattedChild)
        when /\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])*/.test(date.id)
          nextFriday = /\d{4}-\d{2}-\d{2}/.exec(date.id)
          nextWeekendCount += date.count
          formattedNextWeekendChild = _createNewFacet(ID_NEXT_WEEKEND, FRIENDLY_NEXT_WEEKEND, date.id, date.count)
        else
          if date.count?
            nextWeekCount += date.count
          break

    formattedNextFriday = moment(nextFriday, DATE_FORMAT)

    # this weekend calc
    thisFriday = formattedNextFriday.subtract(7, 'day')
    formattedThisFriday = "#{thisFriday.format(DATE_FORMAT)}"
    thisSunday = formattedNextFriday.add(2, 'day')
    formattedThisSunday = "#{thisSunday.format(DATE_FORMAT)}"
    thisWeekendRapi = "[#{formattedThisFriday}..#{formattedThisSunday}]"

    # next week calc
    nextMonday = formattedNextFriday.add(1, 'day')
    formattedNextMonday = "#{nextMonday.format(DATE_FORMAT)}"
    nextSunday = formattedNextFriday.add(6, 'day')
    formattedNextSunday = "#{nextSunday.format(DATE_FORMAT)}"
    nextWeekRapi = "[#{formattedNextMonday}..#{formattedNextSunday}]"

    return null unless formattedChildren.length > 0

    thisWeekendFacet = _createNewFacet(ID_THIS_WEEKEND, FRIENDLY_THIS_WEEKEND, thisWeekendRapi, thisWeekendCount)
    formattedChildren.push(thisWeekendFacet)

    nextWeekFacet = _createNewFacet(ID_NEXT_WEEK, FRIENDLY_NEXT_WEEK, nextWeekRapi, (nextWeekCount + nextWeekendCount))
    formattedChildren.push(nextWeekFacet)

    if formattedNextWeekendChild?
      formattedChildren.push(formattedNextWeekendChild)

    formattedChildren

_createNewFacet = (id, friendlyName, rapiId, count) ->
  facet =
    count: count
    id: id
    rapiId: rapiId
    friendlyName: friendlyName
  facet